import { render, staticRenderFns } from "./ResturantInfo.vue?vue&type=template&id=7d2f9e30&scoped=true&"
import script from "./ResturantInfo.vue?vue&type=script&lang=ts&"
export * from "./ResturantInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ResturantInfo.vue?vue&type=style&index=0&id=7d2f9e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2f9e30",
  null
  
)

export default component.exports